export const RoutesURL = {
    dashboard: '/dashboard',
    demo: '/demo',
    redesign: '/redesign',
    bartaco: '/bartaco',
    notFound: '/*',
};
